import styled from "@emotion/styled";
import {
  Collapse,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SideMenu } from "./index";

const MenuListItem = (props: { sideMenuItem: SideMenu }) => {
  const navigate = useNavigate();

  const SidebarListItemButton = styled(ListItemButton)(() => ({
    color: "white",
    paddingLeft: "30px"
  }));

  const SidebarListItemIcon = styled(ListItemIcon)(() => ({
    color: "white",
    minWidth: "30px",
    marginRight: "8px"
  }));

  const [open, setOpen] = useState(window.location.pathname?.includes(props?.sideMenuItem?.url ?? "") ?? false);
  
  return (
      <>
        <SidebarListItemButton
          onClick={() => {
            navigate(props.sideMenuItem?.url ?? "");
            setOpen(!open);
          }}
        >
          <SidebarListItemIcon sx={{color: "white"}}>{props.sideMenuItem?.icon}</SidebarListItemIcon>
          <ListItemText><Typography variant="h2">{props.sideMenuItem?.name}</Typography></ListItemText>
        </SidebarListItemButton>
        <Collapse in={open}>
          {props.sideMenuItem?.children?.map((child) => {
            return (
              <SidebarListItemButton
                onClick={() => {
                  navigate(child?.url ?? "");
                }}
                sx={{paddingLeft: 5}}
                key={child?.id + "_collapse_button"}
              >
                  <SidebarListItemIcon sx={{color: "white"}}>{child?.icon}</SidebarListItemIcon>
                  <ListItemText><Typography variant="h2">{child?.name}</Typography></ListItemText>
              </SidebarListItemButton>
            );
          })}
        </Collapse>
      </>
  );
};

export default MenuListItem;
